import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from "@angular/common";
import { ServiceStock } from 'src/app/service-stock.service';

declare let $: any;

@Component({
  selector: 'app-loan-ui',
  templateUrl: './loan-ui.component.html',
  styleUrls: ['./loan-ui.component.scss']
})
export class LoanUiComponent implements OnInit {

//isPaymentLanding:boolean = false;
isPaymentAuth: boolean = false;
  paymentOption: string;
constructor(
  public services: ServiceStock,
  private router: Router,
  location: Location) {
  router.events.subscribe(val => {

    var paths = location.path().split('/home/');
    if (paths.length == 2) {
      this.setHeaderName(paths[1].split('/')[1]);
      if (paths[1] == "payments/paymentAuth") {
        this.isPaymentAuth = true;
      } else {
        this.isPaymentAuth = false;
      }
    }
  });
}

ngOnInit() {
  this.services.retailStock.paymentOption = "repayment";
  this.services.http.ActiveTab = "payments";
}
setHeaderName(path) {
  switch (path) {
    case 'repayment-schedule':
      this.paymentOption = "Repayment Schedule";
      break;
    case 'disbursement-schedule':
      this.paymentOption = "Disbursement Schedule";
      break;
    case 'loan-closure-simulation':
      this.paymentOption = "Loan Closure";
      break;
    default:
      break;
  }
}

gotoTransfer() {
    this.services.router.navigate(['/home/transactions']);
}

}


export class CalendarDay {
  public date: Date;
  public title: string;
  public isPastDate: boolean;
  public isToday: boolean;
  public nextMonth: number;
  public utcDate;

  constructor(d: Date) {
    this.date = d;
    this.utcDate = `${("0" + d.getDate()).slice(-2)}/${(
      "0" +
      (d.getMonth() + 1)
    ).slice(-2)}/${d.getFullYear()}`;
    this.isPastDate = d.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
    this.isToday = d.setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0);
  }
}


export interface ISelectedInstalmentOption {
  month: number;
  installmentAmount: string;
  fee: string;
  installmentSchedule: Array<any>;
}